import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { SidenavModel } from "../../models/sidenav.model";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { Tooltip } from "primeng/tooltip";
import { SvgIconComponent } from "@app/kernel/tools/svg-icon/components/svg-icon/svg-icon.component";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: "app-icons-bar",
  imports: [RouterLink, TranslatePipe, Tooltip, RouterLinkActive, SvgIconComponent, NgTemplateOutlet],
  templateUrl: "./icons-bar.component.html",
  styleUrl: "./icons-bar.component.scss",
  host: {
    class: "icons-bar-content flex-col-between",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconsBarComponent {
  mainLinks = input<SidenavModel[]>([]);

  onSelectItem = output<SidenavModel>();

  selectItem(item: SidenavModel) {
    this.onSelectItem.emit(item);
  }
}
